import { Link } from "react-router-dom";
import { Star } from "lucide-react";

export default function ProductCard({ product }) {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="card-flat group block overflow-hidden"
    >
      <div className="aspect-square bg-[#F2EFEB] overflow-hidden">
        {product.images?.[0] ? (
          <img src={product.images[0]} alt={product.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full grid place-items-center text-[#C3B9A6] font-serif text-4xl">स</div>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-center gap-2 mb-2">
          <span className="badge-swadeshi">Swadeshi</span>
          <span className="label-caps">{product.region}</span>
        </div>
        <h3 className="font-serif text-lg text-[#13294B] leading-tight line-clamp-2">{product.title}</h3>
        <div className="mt-3 flex items-end justify-between">
          <div className="text-xl font-bold text-[#0D141C]">₹{product.price.toLocaleString('en-IN')}</div>
          {product.rating > 0 && (
            <div className="flex items-center gap-1 text-sm text-[#4A5568]">
              <Star className="w-3.5 h-3.5 fill-[#E25A24] text-[#E25A24]" />
              {product.rating}
            </div>
          )}
        </div>
        <div className="mt-2 text-xs text-[#718096]">by {product.vendor_name}</div>
      </div>
    </Link>
  );
}
